import React from "react";
import { ChevronRight } from "lucide-react";
import { useDelayedUnmount } from "../../../hooks/useDelayedUnmount";
import { useLastPresentValue } from "../../../hooks/useLastPresentValue";

// 画布右键空白处的菜单（创建节点 / 整理 等）
// 受控显示：传入 menu={x, y} 时显示
export default function PaneContextMenu({ menu, items, hoveredSubmenu, onHoverSubmenu, onClose }) {
  // 出场动画：延迟卸载（缓存 menu 供退场渲染）
  const { mounted, exiting } = useDelayedUnmount(!!menu, 150);
  // 缓存最后一份 menu，供退场动画渲染最后一帧
  const effectiveMenu = useLastPresentValue(menu);
  if (!mounted || !effectiveMenu) return null;

  return (
    <div
      className={`absolute z-50 rounded-lg p-1 ${exiting ? "animate-out fade-out zoom-out-95 duration-150" : "animate-in fade-in zoom-in-95 duration-150"}`}
      style={{
        left: effectiveMenu.x,
        top: effectiveMenu.y,
        backgroundColor: 'var(--color-bg-secondary)',
        border: '1px solid var(--color-border-primary)',
        minWidth: 180,
        boxShadow: 'var(--shadow-dropdown)',
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="relative"
          onMouseEnter={() => item.submenu && onHoverSubmenu(index)}
          onMouseLeave={() => item.submenu && onHoverSubmenu(null)}
        >
          <button
            className="w-full px-3 py-1.5 flex items-center gap-2 text-left text-xs transition-colors duration-150 rounded-md hover:bg-[var(--color-bg-tertiary)]"
            style={{ color: 'var(--color-text-primary)' }}
            onClick={item.submenu ? undefined : item.action}
          >
            <span style={{ color: 'var(--color-text-muted)' }}>{item.icon}</span>
            <span className="flex-1">{item.label}</span>
            {item.submenu && <ChevronRight size={14} style={{ color: 'var(--color-text-muted)' }} />}
          </button>

          {item.submenu && hoveredSubmenu === index && (
            <div
              className="absolute left-full top-0 ml-1 rounded-lg overflow-hidden z-[60] py-1 animate-in fade-in duration-150"
              style={{
                backgroundColor: 'var(--color-bg-secondary)',
                border: '1px solid var(--color-border-primary)',
                minWidth: 150,
                boxShadow: 'var(--shadow-dropdown)',
              }}
            >
              {item.submenu.map((subItem, subIndex) => (
                <button
                  key={subIndex}
                  className="w-full px-3 py-1.5 flex items-center gap-2 text-left text-xs transition-colors duration-150 rounded-md hover:bg-[var(--color-bg-tertiary)]"
                  style={{ color: 'var(--color-text-primary)' }}
                  onClick={() => {
                    subItem.action();
                    onClose();
                  }}
                >
                  <span style={{ color: 'var(--color-text-muted)' }}>{subItem.icon}</span>
                  <span>{subItem.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
